// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/rco-and-drco-remote-outlets.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/rco-and-drco-remote-outlets/rco-and-drco-remote-outlets.js';

mount([g0]);
